import { supabase } from '@/services/supabase/client';

/**
 * "Esta conta é da plataforma?" — a única pergunta de acesso da moderação.
 *
 * ## Por que a resposta vem de uma RPC, e não de uma consulta
 *
 * `platform_admins` tem RLS **sem policy nenhuma**: só o service role enxerga a
 * tabela. Um `select` de cliente volta vazio para todo mundo, inclusive para
 * quem está lá dentro. `is_platform_admin()` é `security definer` e exposta ao
 * cliente justamente para ser este caminho — é o **único** que existe.
 *
 * ## Por que mora em `services/`, e não em `modules/platform`
 *
 * Pelo mesmo motivo de `services/notifications` (docs/01, "quando um service de
 * módulo desce para services/"): o segundo consumidor é `components/layouts/`,
 * que **não pode** importar de `modules/`. O item "Plataforma" só aparece no
 * menu para quem a função devolve `true`, e o menu é layout. O módulo continua
 * dono da apresentação — a fila, os cartões, o redirecionamento; daqui sai só a
 * pergunta.
 *
 * ⚠️ A resposta **não** é a autorização. Quem barra é a RLS de
 * `institution_reports` e `help_request_reports`; isto existe para não haver
 * tela vazia nem item de menu que leva a lugar nenhum. Um `true` forjado no
 * cliente abre uma fila que o banco devolve sem linhas.
 */
export const platformAccessService = {
  async amIPlatformAdmin(): Promise<boolean> {
    const { data, error } = await supabase.rpc('is_platform_admin');

    if (error) throw error;

    return data ?? false;
  },
};
